<template>
<div class="options">
    {{ record.salary }}
    <div class="options-group">
      <div class="options-button">
        <img @click="handleRecover" class="options-icon" src="@/assets/img/trash/wiki-table-refresh.svg"/>
        <div class="tip tip-refresh">
          <span>{{$t("还原")}}</span>
        </div>
      </div>
      <div class="options-button">
        <img @click="handleDelete" class="options-icon" src="@/assets/img/trash/wiki-trash.svg"/>
        <div class="tip tip-delete">
          <span>{{$t("彻底删除")}}</span>
        </div>
      </div>
    </div>
    <CommonDialog :show="showDeleteTip" :title="$t('确定要删除吗？')" :content="$t('删除后文件将不可还原')" :cancelText="$t('取消')" :okText="$t('删除')" :handleCancel="handerDeleteTipCancel" :handleOk="handerDeleteTipOk"></CommonDialog>
  </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import CommonDialog from './commonDialog.vue';
import { deletRecycleList, recoverRecycleList } from '../../core/api/trashApi';
import { mapState } from "vuex";

export default {
  name: 'test_view',
  components: {
    CommonDialog },

  computed: {
    ...mapState({
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo }) },


  props: {
    record: {
      type: (Object as any),
      default: () => {} } },


  data() {
    return {
      showDeleteTip: false };

  },
  methods: {
    handleBack() {
      this.$router.back();
    },
    handleRecover() {
      console.log('handleRecover:');
      recoverRecycleList([this.record.fileId]).then((result) => {
        console.dir(result);
        const { code, message } = result.data;
        if (code === 200) {
          this.$message.success({
            content: intl.$t("已成功还原1个项目") });

          this.$emit('load-data');
          this.$emit('recover-file');
        } else {
          this.$message.error({
            content: intl.$t("还原失败：") + message });

        }
      }).catch((err) => {
        this.$message.error(intl.$t("网络错误，请重试"));
      });
    },
    handleDelete() {
      console.dir(this.record);
      this.showDeleteTip = true;
    },
    handerDeleteTipOk() {
      this.showDeleteTip = false;
      deletRecycleList([this.record.fileId], this.wikiSpaceInfo.wikiSpaceId).then((result) => {
        console.dir(result);
        const { code } = result.data;
        if (code === 200) {
          this.$message.success({
            content: intl.$t("删除成功") });

          this.$emit('load-data');
        } else {
          this.$message.error({
            content: intl.$t("删除失败") });

        }
      }).catch((err) => {
        this.$message.error(intl.$t("网络错误，请重试"));
      });
    },
    handerDeleteTipCancel() {
      this.showDeleteTip = false;
    } } };
</script>

<style lang="scss" scoped>
.options {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;

  .options-group {
    display: flex;
    flex-flow: row;
    margin-right: 40px;

    .options-button {
      position: relative;

      &:hover {
        .tip {
          display: block;
        }

        .options-icon {
          background-color: #FFFFFF;
        }
      }

      .options-icon {
        cursor: pointer;
        width: 14px;
        height: 14px;
        margin-left: 21px;
        padding: 5px;
        border-radius: 4px;
      }


      .tip {
        position: absolute;
        display: none;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        height: 36px;
        top: -50px;
        color: #767C85;
        letter-spacing: 0;
        line-height: 36px;
        text-align: center;
        z-index: 999;

        span {
          padding: 0 6px;
          white-space: nowrap;
        }
      }

      .tip-refresh {
        left: 15px;
        background: #FFFFFF;
        box-shadow: 0 8px 12px 0 #1213171a;
        border-radius: 8px;
      }

      .tip-delete {
        left: 0px;
        background: #FFFFFF;
        box-shadow: 0 8px 12px 0 #1213171a;
        border-radius: 8px;
      }
    }
  }

}
</style>
